import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { XCircle, ArrowLeft } from "lucide-react";

// California Flag component
const CaliforniaFlag = ({ className = "w-8 h-8" }) => (
  <img 
    src="https://customer-assets.emergentagent.com/job_green-builder-3/artifacts/dnderd21_Cali%20FLAG.png" 
    alt="California" 
    className={`${className} object-contain`}
  />
);

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="absolute inset-0 gradient-hero opacity-50" />
      
      <Card className="relative w-full max-w-md border-primary/20 bg-card/90 backdrop-blur-sm" data-testid="payment-cancel-card">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="w-16 h-16 rounded-full bg-yellow-500/10 flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-yellow-500" />
          </div>
          <h2 className="text-2xl font-bold text-foreground mb-2">Payment Cancelled</h2>
          <p className="text-muted-foreground mb-6">
            Your payment was cancelled. Don't worry - your project draft has been saved.
            You can complete the payment anytime from your dashboard.
          </p>
          
          <div className="space-y-3">
            <Button
              onClick={() => navigate('/dashboard')}
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90"
              data-testid="go-to-dashboard-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Dashboard
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/project/new')}
              className="w-full border-primary/30"
            >
              Start New Project
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
